const state = {
  users: [],
  selectedInternalUserAccount: null,
  serverTotal: 0,
};

const getters = {
  internalUsers: (state) => state.users,
  selectedInternalUser: (state) => state.selectedInternalUserAccount,
  serverTotal: (state) => state.serverTotal,
};

const actions = {
  async fetchInternalUserAccounts(
    { commit },
    {
      id,
      groupId = null,
      results = 10,
      page = 1,
      sortBy = "name",
      sortDesc = false,
      filter = null,
    }
  ) {
    const sortDir = sortDesc[0] === false ? "asc" : "desc";
    const sortkey =
      sortBy === "os"
        ? "extra_info"
        : sortBy === "policy_name"
        ? "policy"
        : sortBy;
    const offset = results * page - results;
    const linkSymbol = groupId || null ? "&" : "?";

    let url = `/restapi/users/${id}/users/`;
    if (groupId) url += `?group_id=${groupId}`;
    if (results) url += `${linkSymbol}limit=${results}`;
    if (page) url += `&offset=${offset}`;
    if (sortBy) url += `&sortkey=${sortkey}`;
    if (sortDir) url += `&sortdir=${sortDir}`;
    if (filter) url += `&filter=${filter}`;
    const response = await this._vm.$http.get(url);
    commit("setUsers", response.data);
    commit("setServerTotal", response.data.total);
  },

  async fetchInternalUserAccount({ commit, state }, { id, userId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/users/${userId}`
    );

    const index = state.users.findIndex(
      (account) => account.id === response.data.id
    );

    if (index === -1) {
      commit("addUser", response.data);
    } else {
      commit("updateUser", { idx: index, account: response.data });
    }
    commit("setSelectedInternalUserAccount", response.data);
  },

  async updateInternalUserAccount({ commit }, { id, userId, user }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/users/${userId}`,
      {
        policyid:
          user.policyid === null || user.policy === "None" ? "" : user.policyid,
        description: user.description,
      }
    );
    commit("updateUser", response.data);
  },

  async deleteInternalUserAccounts({ commit }, { userId, users }) {
    const req = {};

    for (const user of users) {
      req[`${user.id}`] = {
        method: "delete",
        path: `users/${userId}/users/${userId}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteUser", ids);
  },
};

const mutations = {
  setUsers: (state, data) => (state.users = data.data),
  setSelectedInternalUserAccount: (state, data) =>
    (state.selectedInternalUserAccount = data),
  addUser: (state, data) => state.users.push(data),
  updateUser: (state, data) => (state.users[`${data.idx}`] = data.account),
  deleteUser(state, users) {
    for (const user of users) {
      state.users = state.users.filter((stateUser) => stateUser.id !== user);
    }
  },
  setServerTotal: (state, data) => (state.serverTotal = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
